import { gql } from 'apollo-boost'

const ABORT_CRAWLING_SESSION = gql`
  mutation abortCrawlingSession($id: ID!) {
    abortCrawlingSession(id: $id) {
      id
      status
    }
  }
`

export default ABORT_CRAWLING_SESSION

